/**
 * A meeting, posted into the transcript by whoever made it.
 *
 * Client-posted like the call row — the payload is `{v:1, t:'meeting', id,
 * title, at?, by}` and relay-server needed no change for it. The title is the
 * creator's text and is drawn as text.
 */

import { ds } from '../../ds';
import { Link } from '../../router';
import { useT } from '../../i18n';
import { formatDay, formatTime } from '../../i18n/format';
import type { MessageMeeting } from '../../lib/relay/types';
import './chat.css';

export function MeetingCard({ meeting }: { meeting: MessageMeeting }) {
  const { Button, Icon } = ds();
  const t = useT();

  return (
    <div className="rl-event">
      <Icon name="VideoCall" size={16} />
      <span className="rl-truncate" style={{ color: 'var(--text-body)', fontWeight: 600 }}>
        {meeting.title}
      </span>
      {meeting.at !== undefined && (
        <span style={{ color: 'var(--text-faint)', fontSize: 11 }}>
          {formatDay(meeting.at)} · {formatTime(meeting.at)}
        </span>
      )}
      <Link to={`/meetings/${meeting.id}`}>
        <Button size="sm" variant="secondary">
          {t('conversation.meeting.join')}
        </Button>
      </Link>
    </div>
  );
}
